/**
 * Returns `value` after a quiet period of `delayMs`. Used to debounce
 * the search-input writes to URL state so we don't refetch the
 * /admin/wheels list on every keystroke.
 */

import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
